import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_SK.json';
import exercises from './FITNESS_EXERCISES_SK.json';
import recipes from './FITNESS_RECIPES_SK.json';

export const FITNESS_DATA_SK: ServiceData = {
  articles,
  exercises,
  recipes,
};
